module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/250.c0a3f553.png";